
import { Suspense } from 'react'

import type { MainPageBlock } from '@entities/MainPageConfig'

import { blockComponents } from '@features/main-page-builder/model/blockRegistry'
import { useAddressStore } from '@features/shipping-methods'



interface BlockMapperProps {
  blocks: MainPageBlock[];
}

export function BlockMapper ({ blocks }: BlockMapperProps) {
  const { shopId } = useAddressStore()

  return (
    <>
      {blocks?.map((block, index) => {
        const BlockComponent = blockComponents[block.type]
        
        if (!BlockComponent) {
          return null
        }

        return (
          <Suspense key={index}>
            <BlockComponent
              block={block}
              payload={block.payload}
              shopId={shopId}
            />
          </Suspense>
        )
      })}
    </>
  )
}